var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkpauseGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0, 0, 160, 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.945,110.602 C70.714,110.793 79.594,112.738 89.072,115.495 C94.965,117.436 100.736,119.728 106.355,122.359 C110.148,124.127 113.691,126.387 116.895,129.079 L116.895,129.079 C129.213,142.901 154.028,95.252 158.671,73.17 C154.733,69.589 151.963,61.09 151.963,51.231 C151.963,45.86 152.095,40.775 154.172,36.908 C153.178,35.769 152.605,34.324 152.548,32.813 C148.072,33.243 141.292,26.189 139.562,17.953 C139.323,17.75 139.096,17.535 138.845,17.332 C134.492,18.962 129.874,19.772 125.226,19.719 C112.813,19.719 106.88,18.729 100.435,6.351 C95.266,13.011 80.728,13.596 76.706,2.77 C72.074,9.932 58.634,12.2 50.267,2.77 C49.706,3.665 42.055,12.2 31.169,7.544 C29.283,10.827 25.082,15.291 19.233,14.074 C10.293,20.829 5.315,26.989 2.749,36.502 C-1.847,53.606 9.779,57.987 14.745,57.987 L29.319,57.987 L50.804,86.538 z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.836,125.128 L119.592,110.661",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.235,24.9 L89.143,12.235",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.833,9.371 L60.675,11.865",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.474,14.933 L98.059,32.969",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.311,12.725 L96.484,27.371",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.22,9.932 L76.849,20.579",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.372,20.985 L25.261,14.778",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.458,50.348 L152.512,35.427",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.621,11.245 L33.377,16.055",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.458,29.913 L139.526,42.637",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.497,19.767 L10.412,30.665",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.346,14.849 L13.73,31.178",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.778,14.109 L53.108,6.983",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.743,13.059 L49.181,5.694",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.755,59.371 C11.21,59.963 12.758,60.294 14.327,60.35 L50.327,60.35 C51.896,60.294 53.443,59.963 54.898,59.371 C56.353,58.78 63.325,55.6 63.325,49.739 C63.325,44.117 55.59,40.19 55.59,40.19 C54.23,39.458 53.049,38.435 52.129,37.194 C51.209,35.953 48.13,31.226 43.177,31.226 C40.812,31.41 38.555,32.296 36.695,33.768 C35.533,34.614 34.016,34.8 32.685,34.258 C31.008,33.519 29.204,33.114 27.373,33.064 C22.348,33.064 17.275,38.149 17.275,38.149 C16.191,39.118 14.709,39.508 13.289,39.199 C12.839,39.177 12.389,39.177 11.94,39.199 C6.077,39.206 1.329,43.96 1.329,49.822 C1.329,55.6 9.755,59.371 9.755,59.371 z",
    fill: "#E6FFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.755,59.371 C11.21,59.963 12.758,60.294 14.327,60.35 L50.327,60.35 C51.896,60.294 53.443,59.963 54.898,59.371 C56.353,58.78 63.325,55.6 63.325,49.739 C63.325,44.117 55.59,40.19 55.59,40.19 C54.23,39.458 53.049,38.435 52.129,37.194 C51.209,35.953 48.13,31.226 43.177,31.226 C40.812,31.41 38.555,32.296 36.695,33.768 C35.533,34.614 34.016,34.8 32.685,34.258 C31.008,33.519 29.204,33.114 27.373,33.064 C22.348,33.064 17.275,38.149 17.275,38.149 C16.191,39.118 14.709,39.508 13.289,39.199 C12.839,39.177 12.389,39.177 11.94,39.199 C6.077,39.206 1.329,43.96 1.329,49.822 C1.329,55.6 9.755,59.371 9.755,59.371 z",
    fillOpacity: 0,
    stroke: "#79BA42",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.53,116.045 C24.079,113.24 36.851,110.47 49.945,110.602 C70.714,110.793 79.594,112.738 89.072,115.495 C94.965,117.436 100.736,119.728 106.355,122.359 C110.148,124.127 113.691,126.387 116.895,129.079",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.319,54.108 C29.319,54.108 42.628,65.841 46.746,73.444 C46.304,65.519 46.746,49.93 46.746,49.93 L60.723,45.836 L60.723,69.171 C68.35,61.544 75.978,49.93 75.978,49.93 L96.162,44.809 C73.65,48.772 64.566,77.777 64.566,77.777 L64.566,116.677 C64.566,126.226 79.081,129.461 79.081,129.461 C67.67,125.952 66.059,129.21 66.512,131.944 C64.686,130.571 60.914,129.461 54.063,126.262 C47.211,123.063 37.627,132.23 37.627,132.23 L42.234,126.715 C40.455,123.982 29.343,129.461 29.343,129.461 C38.08,123.982 41.16,122.156 41.912,110.279 C42.664,98.403 41.912,80.045 41.912,80.045 C41.912,80.045 33.556,62.952 25.296,57.856",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.319,54.108 C29.319,54.108 42.628,65.841 46.746,73.444 C46.304,65.519 46.746,49.93 46.746,49.93 L60.723,45.836 L60.723,69.171 C68.35,61.544 75.978,49.93 75.978,49.93 L96.162,44.809 C73.65,48.772 64.566,77.777 64.566,77.777 L64.566,116.677 C64.566,126.226 79.081,129.461 79.081,129.461 C67.67,125.952 66.059,129.21 66.512,131.944 C64.686,130.571 60.914,129.461 54.063,126.262 C47.211,123.063 37.627,132.23 37.627,132.23 L42.234,126.715 C40.455,123.982 29.343,129.461 29.343,129.461 C38.08,123.982 41.16,122.156 41.912,110.279 C42.664,98.403 41.912,80.045 41.912,80.045 C41.912,80.045 33.556,62.952 25.296,57.856",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.308,82.158 L52.308,86.932 C52.308,86.932 47.223,90.728 50.231,95.18 C53.239,99.632 52.308,102.724 52.308,102.724",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.308,82.158 L52.308,86.932 C52.308,86.932 47.223,90.728 50.231,95.18 C53.239,99.632 52.308,102.724 52.308,102.724",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.075,94.333 C53.211,95.489 52.649,96.843 52.439,98.272",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.075,94.333 C53.211,95.489 52.649,96.843 52.439,98.272",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.553,105.732 L59.553,116.761 C59.553,116.761 60.067,121.535 61.941,122.729",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.553,105.732 L59.553,116.761 C59.553,116.761 60.067,121.535 61.941,122.729",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.128,63.848 L56.128,55.623",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.128,63.848 L56.128,55.623",
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M101.652,55.612 C100.198,56.203 98.65,56.534 97.081,56.59 L61.081,56.59 C59.512,56.534 57.964,56.203 56.51,55.612 C55.055,55.02 48.083,51.828 48.083,45.967 C48.083,40.357 55.817,36.418 55.817,36.418 C57.181,35.665 58.363,34.622 59.279,33.362 C60.195,32.103 63.277,27.394 68.231,27.394 C70.585,27.589 72.828,28.478 74.676,29.949 C75.837,30.799 77.356,30.985 78.687,30.438 C80.363,29.7 82.167,29.294 83.999,29.244 C89.036,29.244 94.109,34.329 94.109,34.329 C95.19,35.303 96.675,35.695 98.095,35.38 L99.432,35.38 C105.293,35.38 110.043,40.131 110.043,45.991 C110.079,51.828 101.652,55.612 101.652,55.612 z",
    fill: "#E6FFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.652,55.612 C100.198,56.203 98.65,56.534 97.081,56.59 L61.081,56.59 C59.512,56.534 57.964,56.203 56.51,55.612 C55.055,55.02 48.083,51.828 48.083,45.967 C48.083,40.357 55.817,36.418 55.817,36.418 C57.181,35.665 58.363,34.622 59.279,33.362 C60.195,32.103 63.277,27.394 68.231,27.394 C70.585,27.589 72.828,28.478 74.676,29.949 C75.837,30.799 77.356,30.985 78.687,30.438 C80.363,29.7 82.167,29.294 83.999,29.244 C89.036,29.244 94.109,34.329 94.109,34.329 C95.19,35.303 96.675,35.695 98.095,35.38 L99.432,35.38 C105.293,35.38 110.043,40.131 110.043,45.991 C110.079,51.828 101.652,55.612 101.652,55.612 z",
    fillOpacity: 0,
    stroke: "#79BA42",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.618,44.105 C76.479,44.105 81.229,39.354 81.229,33.494 C81.229,27.872 73.483,23.945 73.483,23.945 C72.123,23.192 70.945,22.149 70.033,20.889 C69.122,19.63 66.035,14.921 61.081,14.921 C58.712,15.103 56.451,15.989 54.588,17.463 C53.429,18.307 51.917,18.493 50.589,17.953 C48.913,17.214 47.109,16.809 45.278,16.759 C40.241,16.759 35.168,21.844 35.168,21.844 C34.084,22.813 32.601,23.203 31.181,22.894 C30.732,22.871 30.281,22.871 29.832,22.894 C24.107,23.086 19.565,27.783 19.565,33.512 C19.565,39.24 24.107,43.937 29.832,44.129",
    fill: "#E6FFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.618,44.105 C76.479,44.105 81.229,39.354 81.229,33.494 C81.229,27.872 73.483,23.945 73.483,23.945 C72.123,23.192 70.945,22.149 70.033,20.889 C69.122,19.63 66.035,14.921 61.081,14.921 C58.712,15.103 56.451,15.989 54.588,17.463 C53.429,18.307 51.917,18.493 50.589,17.953 C48.913,17.214 47.109,16.809 45.278,16.759 C40.241,16.759 35.168,21.844 35.168,21.844 C34.084,22.813 32.601,23.203 31.181,22.894 C30.732,22.871 30.281,22.871 29.832,22.894 C24.107,23.086 19.565,27.783 19.565,33.512 C19.565,39.24 24.107,43.937 29.832,44.129",
    fillOpacity: 0,
    stroke: "#79BA42",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M30.823,9.55 L27.863,15.912",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.11,26.75 L97.952,9.932",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.259,13.715 L67.204,9.55",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.577,15.494 L72.552,6.96",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.039,15.506 L76.67,5.575",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.711,9.395 L73.626,20.304",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.006,14.074 L57.87,7.938",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.252,19.767 L112.168,39.235",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.842,65.96 L131.278,49.99",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.199,75.259 L123.842,46.003",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.726,63.155 L115.08,75.259",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.925,76.297 L123.376,96.768",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.174,46.588 L129.44,63.155",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.957,46.958 L111.368,61.078",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.632,108.763 L129.213,120.401",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.518,96.768 L129.726,72.728",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.277,86.884 L126.694,66.688",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.555,85.094 L128.306,94.225",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.038,78.398 L122.087,67.572",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.253,29.292 L112.729,19.684",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.241,96.768 L115.164,81.919",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.451,95.371 L105.866,115.913",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.213,101.411 L120.929,119.16",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.306,94.225 L121.096,108.883",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.213,117.047 L118.793,100.778",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.59,113.49 L121.407,126.739",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.34,37.671 L139.526,22.274",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.357,73.301 L142.617,55.576",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.774,110.196 L144.849,77.884",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.985,47.435 L135.575,80.487",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.684,77.001 L131.469,96.756",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.372,60.589 L131.946,67.93",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.881,33.792 L133.534,45.251",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.129,95.968 L157.621,73.48",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.971,112.44 L145.016,95.18",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.9,34.174 L116.238,20.579",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.107,19.958 L113.338,46.003",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.217,34.89 L7.118,28.683",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.474,74.841 L150.985,56.59",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.962,75.056 L152.107,63.848",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.149,96.445 L153.849,69.207",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.19,16.747 L42.914,8.762",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.598,11.865 L80.859,21.271",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.939,12.235 L86.827,25.329",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.732,21.88 L101.879,8.702",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.772,26.451 L140.612,31.381",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.652,56.59 L148.86,32.837",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.421,28.146 L109.256,17.786",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.234,24.112 L119.151,43.58",
    fillOpacity: 0,
    stroke: "#999999",
    strokeWidth: 1,
    strokeDasharray: "4,1,2,1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.929,17.022 L128.186,37.97 L133.164,37.97 L121.586,60.887 L126.145,43.281 L121.371,43.281 L127.816,19.707",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkpauseGoal);
export default __webpack_public_path__ + "static/media/workpause-goal.520fc190.svg";
export { ForwardRef as ReactComponent };